import React, { Component } from "react"
import classNames from "classnames"

import B from "@cirrus/legacy/app-components/buttons/button/index.jsx"

import styles from "./button.less"

class Button extends Component {
  componentDidMount() {
    this.props.onMount && this.props.onMount()
  }

  render() {
    const { isActive, text, disabled, dataQa, onClick, setRef, type, className } = this.props

    return (
      <div
        className={classNames(styles.container, {
          [styles.containerActive]: isActive,
        })}>
        <span
          className={classNames({
            [styles.arrowHelperActive]: isActive,
          })}
        />
        <B
          getButton={setRef}
          dataQa={dataQa || "control-link"}
          className={classNames(styles.controlLink, className)}
          onClick={onClick}
          type={type || "filled-success"}
          disabled={disabled}>
          {text}
        </B>
      </div>
    )
  }
}

export default Button
